import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import appConfig from '../../../../config/appConfig';
import {amplitude} from '../../../../services/amplitude';
import {
    selectIsAggregatedSettingsFetched,
    selectIsAmplitudeEnabled,
} from '../../../../state/selectors/consumerAggregatedSettings';
import {selectIsConfigInitialized} from '../../../../state/selectors/global';

const useAmplitudeOptOut = () => {
    const isConfigInitialized = useSelector(selectIsConfigInitialized);

    // set optOut from market config
    useEffect(() => {
        if (!isConfigInitialized) return;

        const isAmplitudeEnabledInConfig = appConfig.getIsAmplitudeEnabled();

        amplitude.enableAmplitude(isAmplitudeEnabledInConfig);
    }, [isConfigInitialized]);

    const isAggregatedSettingsFetched = useSelector(selectIsAggregatedSettingsFetched);
    const isAmplitudeEnabled = useSelector(selectIsAmplitudeEnabled);

    // set optOut from consumer aggregatedSetting
    useEffect(() => {
        if (!isAggregatedSettingsFetched) return;

        const isAmplitudeEnabledInConfig = appConfig.getIsAmplitudeEnabled();

        amplitude.enableAmplitude(isAmplitudeEnabledInConfig && isAmplitudeEnabled);
    }, [isAggregatedSettingsFetched, isAmplitudeEnabled]);
};

export default useAmplitudeOptOut;
